// @flow

import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { rgba } from "polished";

import { ScrollableBox } from "src/styles/box";
import * as colors from "src/styles/constants/colors";
import * as radius from "src/styles/constants/radius";
import * as spacing from "src/styles/constants/spacing";

export const Value = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${({ overdue, active, cancelled }) =>
    !active || cancelled ? "center" : overdue ? "space-between" : "center"};

  ${({ location }) =>
    location === "chatroom-header"
      ? `
    min-width: 90px;
    max-width: 200px;
  `
      : `
    width: 90px;
    min-width: 0;
  `}
  padding: 2px 6px;
  border-radius: ${radius.small};

  font-size: 0.625rem;
  line-height: 1rem;
  text-align: center;
  text-transform: uppercase;
  overflow: hidden;
  text-overflow: ellipsis;

  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  background-color: ${({ overdue, disabled, color }) =>
    overdue && !disabled ? colors.close : color || colors.primary};

  color: ${({ disabled, cancelled, overdue, active, textColor }) => {
    if (disabled && !cancelled) return colors.primary;
    if (cancelled || overdue) return colors.brightLight;
    if (active !== undefined && !active) return colors.success;
    return textColor || rgba(colors.secondary, 0.2);
  }};
  ${({ customCss }) =>
    customCss &&
    css`
      ${customCss}
    `}
`;

export const Status = styled.div`
  position: relative;
`;

export const Options = styled(ScrollableBox)`
  z-index: 3;
  position: absolute;
  font-size: 0.625rem;
  top: ${(props) => props.top};
  bottom: ${(props) => props.bottom};
  padding: 1.6em;
  padding-bottom: 0.8em;
  width: 12.5rem;
  max-height: 75vh;
  overflow: auto;
`;

export const SubHeading = styled.li`
  color: ${colors.unifizeBlue};
  letter-spacing: 1px;
`;

export const MenuItem = styled.li`
  margin: 1.25em 0;
  display: flex;
  > ${Value} {
    width: 92%;
    > span {
      display: block;
      width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }
  align-items: center;
  justify-content: space-between;
`;

export const DueStatus = styled.div`
  > div {
    ${({ location }) =>
      location === "chatroom-header"
        ? `
      min-width: 64px;
      max-width: 160px;
    `
        : `
      width: 64px;
    `}
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-right: ${spacing.space_s};
    ${(props) => props.completed && `color: ${colors.success}`};
  }
`;

export const StatusTextContainer = styled.span`
  display: block;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const ArchiveIconContainer = styled.span`
  width: auto !important;
  display: inline !important;
  line-height: 75%;
  padding: 0 4px;
  margin: 0;
`;
